import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button, Divider, Notification } from 'base-ui'

export const DirectContactFormErrorContent: FC<{
  subjectLine?: string
}> = ({ subjectLine = '' }) => {
  const intl = useIntl()

  const emailAddress = intl.formatMessage({
    id: 'contactForm.label.email.invitation.email',
  })

  return (
    <div>
      <Notification className="my-6" severity="error">
        {intl.formatMessage({ id: 'general.error' })}
      </Notification>
      <Divider className="mb-6">
        <FormattedMessage id="general.label.or" />
      </Divider>
      <div className="flex flex-col items-center gap-4 tablet:mx-auto tablet:w-max">
        <p>
          <FormattedMessage id="contact.error.sendEmail" />
        </p>
        <Button<'a'>
          className="w-full"
          color="secondary"
          href={`mailto:${emailAddress}?subject=${encodeURIComponent(subjectLine)}`}
          size="large"
          slots={{ root: 'a' }}
        >
          <FormattedMessage id="help.centre.others.options.write.us" />
        </Button>
      </div>
    </div>
  )
}
